/*
 *
 * TransactionDetailsNotePopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 06-Jun-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.transactions.DetailsNotes.transactionNoteTitle'
      defaultMessage='Note transazione'
    />
  ),
  description: (
    <PortalMessage
      id='t.app.transactions.DetailsNotes.transactionNoteDescription'
      defaultMessage='Le note da te inserite saranno visibili anche agli utenti secondari.'
    />
  ),
  primaryButtonLabel: (
    <PortalMessage
      id='t.app.confirm'
      defaultMessage='Conferma'
    />
  ),
  close: (
    <PortalMessage
      id='t.app.close'
      defaultMessage='Chiudi'
    />
  ),
  labelPortalText: (
    <PortalMessage
      id='t.app.transactions.DetailsNotes.transactionModifyNoteSubKeyword'
      defaultMessage='Parola chiave'
    />
  ),
  titleGenericCard: (
    <PortalMessage
      id='t.app.transactions.DetailsNotes.titleGenericCard'
      defaultMessage='Aggiungi delle parole chiave'
    />
  ),
  descriptionGenericCard: (
    <PortalMessage
      id='t.app.transactions.DetailsNotes.descriptionGenericCard'
      defaultMessage='Aggiungi delle parole chiave come nome cliente, tipologia prodotto o altre info dell’ordine per ritrovare rapidamente la transazione attraverso i filtri.'
    />
  ),
  placeholderPortaLink: (
    <PortalMessage
      id='t.app.transactions.DetailsNotes.placeholderPortaLink'
      defaultMessage='Inserisci parole chiave'
    />
  ),
  requiredError: (
    <PortalMessage
      id='t.app.error.requiredField'
      defaultMessage='Il campo è obbligatorio'
    />
  ),
  countChart: (
    <PortalMessage
      id='t.app.transactions.DetailsNotes.countChart'
      defaultMessage='caratteri disponibili'
    />
  )

}

export default formattedMessage
